import React, {useMemo} from 'react';
import {useIntl} from 'react-intl';
import * as commonColumnFormatters from '../../_common/column-formatters';
import * as columnFormatters from './column-formatters';
import {useBankStatementsContext} from '../context/BankStatementsContext';
import {formattingPrice} from '../../_common/utils/format';
import PlainGrid from '../../_common/components/PlainGrid';

export function BankStatementsTable() {
  const intl = useIntl();
  const {tableRows} = useBankStatementsContext();
  const columns = useMemo(() => [
    {
      accessor: 'createdAt',
      Header: intl.formatMessage({id: `bankStatements-matchedInvoices-column-createdAt`, defaultMessage: 'Date'})
    },
    {
      accessor: 'amount',
      Header: intl.formatMessage({id: `bankStatements-matchedInvoices-column-amount`, defaultMessage: 'Amount'})
    },
    {
      accessor: 'description',
      Header: intl.formatMessage({
        id: `bankStatements-matchedInvoices-column-description`,
        defaultMessage: 'Description'
      })
    },
    {
      accessor: 'matchedCount',
      Header: intl.formatMessage({
        id: `bankStatements-matchedInvoices-column-matchedCount`,
        defaultMessage: 'Matched Count'
      })
    },
    {
      accessor: 'actions',
      Header: ''
    },
  ], [intl]);
  const data = useMemo(() => [
    ...tableRows
      .map((item) => {

        return {
          createdAt: commonColumnFormatters.DateColumnFormatter(item.createdAt),
          amount: commonColumnFormatters.BoldColumnFormatter(formattingPrice(item.amount)),
          description: commonColumnFormatters.NormalColumnFormatter(item.description),
          matchedCount: commonColumnFormatters.BoldColumnFormatter(item.matchedCount),
          actions: columnFormatters.ViewButtonColumnFormatter(item),
        };
      })
  ], [tableRows]);


  return (
    <PlainGrid
      columns={columns}
      data={data}
    />
  );
}

